// extracted by mini-css-extract-plugin
module.exports = {"swapButton":"SearchFieldSwapButton_swapButton__gMtqF"};